import { render } from "./OrderPayoutItem.vue?vue&type=template&id=8473b460"
import script from "./OrderPayoutItem.vue?vue&type=script&lang=js"
export * from "./OrderPayoutItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__